import { Row } from 'Components/Grid';
import { useTranslation } from 'react-i18next';
import { MainContent, TitleMainContent } from '../styles';

export const IndicatorResume = ({ indicatorResume }) => {
  const { t } = useTranslation('mapping');
  return (
    <Row className="mt-4">
      <TitleMainContent xs={8} sm={4} md={4}>
        <Row className="pl-3 font-weight-bold mb-2">{t('ropa.executiveSummary.businessAreas')}</Row>
      </TitleMainContent>
      <MainContent xs={4} sm={2} md={2}>
        <Row className="pl-3" justifyContent="center">
          {indicatorResume.areaQuantity}
        </Row>
      </MainContent>
      <TitleMainContent xs={8} sm={4} md={4}>
        <Row className="pl-3 font-weight-bold mb-2">{t('ropa.executiveSummary.areasWithPersonalData')}</Row>
      </TitleMainContent>
      <MainContent xs={4} sm={2} md={2}>
        <Row className="pl-3" justifyContent="center">
          {indicatorResume.areaPersonalDataQuantity}
        </Row>
      </MainContent>
      <TitleMainContent xs={8} sm={4} md={4}>
        <Row className="pl-3 font-weight-bold mb-2">{t('ropa.executiveSummary.processesLabel')}</Row>
      </TitleMainContent>
      <MainContent xs={4} sm={2} md={2}>
        <Row className="pl-3" justifyContent="center">
          {indicatorResume.processQuantity}
        </Row>
      </MainContent>
      <TitleMainContent xs={8} sm={4} md={4}>
        <Row className="pl-3 font-weight-bold mb-2">{t('ropa.executiveSummary.areasWithSensitiveData')}</Row>
      </TitleMainContent>
      <MainContent xs={4} sm={2} md={2}>
        <Row className="pl-3" justifyContent="center">
          {indicatorResume.areaSensitivePersonalDataQuantity}
        </Row>
      </MainContent>
      <TitleMainContent xs={8} sm={4} md={4}>
        <Row className="pl-3 font-weight-bold mb-2">{t('ropa.executiveSummary.systemsAndAssets')}</Row>
      </TitleMainContent>
      <MainContent xs={4} sm={2} md={2}>
        <Row className="pl-3" justifyContent="center">
          {indicatorResume.assetAndSystemQuantity}
        </Row>
      </MainContent>
      <TitleMainContent xs={8} sm={4} md={4}>
        <Row className="pl-3 font-weight-bold mb-2">{t('ropa.executiveSummary.processesNeedDPIA')}</Row>
      </TitleMainContent>
      <MainContent xs={4} sm={2} md={2}>
        <Row className="pl-3" justifyContent="center">
          {indicatorResume.processDPIAQuantity}
        </Row>
      </MainContent>
      <TitleMainContent xs={8} sm={4} md={4}>
        <Row className="pl-3 font-weight-bold mb-2">{t('ropa.executiveSummary.legalBasesUsed')}</Row>
      </TitleMainContent>
      <MainContent xs={4} sm={2} md={2}>
        <Row className="pl-3" justifyContent="center">
          {indicatorResume.legalBaseQuantity}
        </Row>
      </MainContent>
      <TitleMainContent xs={8} sm={4} md={4}>
        <Row className="pl-3 font-weight-bold mb-2">{t('ropa.executiveSummary.processesNeedLIA')}</Row>
      </TitleMainContent>
      <MainContent xs={4} sm={2} md={2}>
        <Row className="pl-3" justifyContent="center">
          {indicatorResume.processLIAQuantity}
        </Row>
      </MainContent>
    </Row>
  );
};
